/**
 * Hook para logout. Invalida queries y llama authSessionService.logout.
 */
import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";
import { authSessionService } from "../services/authSessionService";

export function useLogout() {
    const queryClient = useQueryClient();

    const logOut = async () => {
        [
            [Queries.USER_INFO],
            [Queries.TRANSACTION_FIND_ALL],
            [Queries.PROGRAM_FIND_ALL],
            [Queries.POINTS_BALANCE_CONVERSION_RATE],
            [Queries.RANDOM_PARTNERS],
            [Queries.PARTNERS_FIND_ALL_INFINITY],
            [Queries.GET_ORGANIZATION_INFO],
        ].forEach((queryKey) => queryClient.removeQueries({ queryKey }));
        await authSessionService.logout();
    };

    return { logOut };
}
